import AccountSettingsPage from './AccountSettingsPage';

export default AccountSettingsPage;
